// @flow

import { useDispatch } from 'react-redux';

import {
  getCart,
  setCartReselleeId,
  selectReselleeIdOfCartProducts,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import {
  updateCartProductOwner,
  updateProductsPayload,
} from 'src/Cart/AccountChoice/modules/actions';
import { setPatchContactsFlag } from 'src/Cart/DomainContacts/Wizard/modules/actions';
import { useAppSelector } from 'src/hooks/useAppSelector';
import { unsetReselleeFromConfiguration } from 'src/modules/configurations';

type Props = {
  onSuccess?: () => void,
};

export function useApplyOrgaProductOwner({
  onSuccess,
}: Props): (newOwnerId: string) => Promise<void> {
  const dispatch = useDispatch();
  const currentReselleeId = useAppSelector(selectReselleeIdOfCartProducts);
  const translator = useTranslator();

  return async (newOwnerId: string) => {
    if (!newOwnerId) return;

    try {
      // Api call to update the cart product owner
      await dispatch(updateCartProductOwner(newOwnerId));
      // remove resellee if needed
      if (currentReselleeId) {
        dispatch(setCartReselleeId(null));
        // $FlowFixMe[not-an-array] bad action type
        dispatch(setPatchContactsFlag(true));
        await Promise.all([
          // FIX:updateProductsPayload does not remove correctly the resellee from the product payload
          dispatch(updateProductsPayload({ translator })),
          // WARN: unsetReselleeFromConfiguration may do the same job has updatecartProductOwnership
          // to be remove in the future
          dispatch(unsetReselleeFromConfiguration()),
        ]);
      }
      // WARN: updateCartProductOwnership is WIP
      // https://gitlab.corp.gandi.net/gandi/squad-shop/app-shop/-/work_items/899
      // ** UNPLUG **
      // await dispatch(updateCartProductOwnership());
      // ** UNPLUG **
      await dispatch(getCart());
      if (typeof onSuccess === 'function') onSuccess();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      // pass
    }
  };
}
